import { dimensions } from '~/store/dimensions.js';

export default function ({ app: { router }, store }) {
  router.beforeResolve(({ name }, from, next) => {
    // name es null cuando la url no matchea ninguna ruta de Nuxt: cualquier 404,
    // o las landings que ahora sirve Framer si el request llega hasta aca.
    // Sin este guard el hook tira y vue-router aborta la navegacion entera.
    const dimension = name ? dimensions.find((item) => name.includes(item.path)) : null;
    store.dispatch('dimensions/ACTUAL_DIMENSION', dimension?.name || dimensions[0].name);
    next();
  });
}
